module.exports = __webpack_public_path__ + "img/8.b80c9762.png";